import Link from 'next/link';

import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import { SpotIllustration } from '@zg-rentals/visual-cohesion';

import { ROUTES } from '../../../../../constants/urls';

export const ThanksPage = () => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: '600',
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <SpotIllustration name="core-value-we-play-to-win-2025" />
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '200' }}>
        <Heading level={2} textStyle="heading-xs">
          Thanks for sharing
        </Heading>
        <Paragraph>
          We’ll use your answers to tailor your experience. Go to your{' '}
          <Link href={ROUTES.ACCOUNT_SETTINGS}>account settings page</Link> anytime you need to update your role or the
          number of units you manage.
        </Paragraph>
      </Box>
    </Box>
  );
};

export default ThanksPage;
